import { render, staticRenderFns } from "./DashboardWidgetContractWindow.vue?vue&type=template&id=05dbaac0&scoped=true"
import script from "./DashboardWidgetContractWindow.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetContractWindow.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetContractWindow.vue?vue&type=style&index=0&id=05dbaac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbaac0",
  null
  
)

export default component.exports